import React from "react"
import Tippy from "@tippyjs/react/headless"
import { Placement as TippyPlacement } from "tippy.js"
import styled from "styled-components"

export type Placement = TippyPlacement

interface TooltipProps {
  children?: React.ReactElement
  content?: string | (() => JSX.Element)
  trigger?: string
  placement?: Placement
  offset?: unknown // Should be [number, number] but eslint can't parse that currently
}

const TooltipContainer = styled.div`
  border: 1px solid #cccccc;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  background: white;
  border-radius: 8px;
  max-width: 650px;
`
const Arrow = styled.div`
  &,
  &:before {
    position: absolute;
    width: 15px;
    height: 15px;
    background: white;
    border: 1px solid #cccccc;

    ${TooltipContainer}[data-placement^="top"] > & {
      bottom: -4.5px;
      border-top: 0;
      border-left: 0;
    }

    ${TooltipContainer}[data-placement^="bottom"] > & {
      top: -4.5px;
      border-bottom: 0;
      border-right: 0;
    }

    ${TooltipContainer}[data-placement^="right"] > & {
      left: -4.5px;
      border-right: 0;
      border-bottom: 0;
    }

    ${TooltipContainer}[data-placement^="left"] > & {
      right: -4.5px;
      border-left: 0;
      border-top: 0;
    }
  }

  visibility: hidden;

  &:before {
    visibility: visible;
    content: "";
    transform: rotate(45deg);
  }
`

const Tooltip = ({ children, content, placement, offset, ...otherProps }: TooltipProps): JSX.Element => {
  return (
    <Tippy
      render={(attrs) => (
        <TooltipContainer {...attrs}>
          {typeof content === "string" ? content : content()}
          <Arrow data-popper-arrow="" />
        </TooltipContainer>
      )}
      placement={placement}
      offset={offset as any}
      {...otherProps}
    >
      {children}
    </Tippy>
  )
}

export default Tooltip
